import { Injectable } from '@angular/core';
import { ApiService } from '../api-service/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class ClientConfigService {

	private _clientConfig: BehaviorSubject<any>
  private clientId: any

  	constructor(private apiService: ApiService) {

  		this._clientConfig = new BehaviorSubject({})

  	}

  	get clientConfig(){
  		return this._clientConfig
  	}

  	set clientConfig(data){
  		this._clientConfig.next(data)
  	}


  	retrieveClientConfig(){
		console.log(this.apiService.decode())
      this.clientId = this.apiService.decode().marketplaceId;

  		return new Promise((resolve, reject) => {
  			this.apiService.request('GET', '/provider/658')
	  		.then((response)=>{
	  			this._clientConfig.next(response)
	  			resolve()
	  		})
	  		.catch(error=>{
	  			console.log(error)
	  			reject(error.message)
	  		})

  		})
  		
  	}

}


// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/rooster/admin/src/app/client-config-service/client-config.service.ts